import { createContext, useContext } from 'react';
import type { AddMonitorStore } from './store';

const AddMonitorStoreContext = createContext<AddMonitorStore | null>(null);

export function useAddMonitorStoreContext() {
	const ctx = useContext(AddMonitorStoreContext);
	if (ctx === null) {
		throw new Error(
			'useFormContext was called outside of FormProvider context'
		);
	}

	return ctx;
}

export { AddMonitorStoreContext };
